import Vue from 'vue'
import { getAction, postAction } from './http'//引入封装的get post方法

//侧边栏
const getAside = (params)=>getAction("/api/official/website/categories/sidebar",params);
//详情文章
const getArticle = (params)=>getAction("/api/official/website/articles/getArticle",params);
//热门产品
const hotProducts = (params)=>getAction("/api/official/website/articles/getHotArticle",params);
//产品选型表
const productTable = (params)=>getAction("/api/official/website/productTables/product",params);
//其他芯片
const otherChip = (params)=>getAction("/api/official/website/productTables/productOtherChip",params);
//关于我们
const aboutUs = (params)=>getAction("/api/official/website/articles/aboutUs",params);
//新闻动态
const news = (params)=>getAction("/api/official/website/articles/news",params);
//新闻详情
const newItem = (id)=>getAction("/api/official/website/articles/getArticleById?id="+id);
//荣誉与认证
const certification = (params)=>getAction("/api/official/website/articles/certification",params);
//法律声明
const statement = (params)=>getAction("/api/official/website/articles/statement",params);
//二级分类（页脚下动态菜单）
const secondMenu = (params)=>getAction("/api/official/website/categories/secondMenu",params);
export {
    getAside,
    getArticle,
    hotProducts,
    productTable,
    otherChip,
    aboutUs,
    news,
    newItem,
    certification,
    statement,
    secondMenu,
}